import React, { useCallback, useEffect, useState } from "react";
import PanelWrapper from "./PanelWrapper";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronRight,
  faHeartBroken,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserFavoritesListAction,
  toggleFavoriteAction,
} from "../../Services/Store/Actions/SpaceActions";
import ActionMenu from "../../Components/ActionMenu";
import useAuth from "../../Hooks/useAuth";
import { formatArea, formatSpaceRate, showToast } from "../../utils/helpers";
import { webSiteUrl } from "../../utils/env";
import Pagination from "../../Components/Pagination";

const UsersFavoritesList = () => {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { favoriteList } = useSelector((state: any) => state.auth);

  const [loading, setLoading] = useState(false);
  const [favoritesList, setFavoriteList] = useState([]);
  const [removing, setRemoving] = useState<Record<string, boolean>>({});

  const [pagination, setPagination] = useState({
    totalItems: null,
    itemsPerPage: null,
    currentPage: null,
    totalPages: null,
    nextPage: null,
  });

  const getFavoriteList = useCallback((page = 1) => {
    if (!loading) {
      setLoading(true);

      const data = {
        page,
        limit: 15,
        id: user.id,
      };

      getUserFavoritesListAction(data, dispatch)
        .then((res) => {
          //
          if (res.type === "success") {
            setPagination(res.pagination);
          }
        })
        .catch((err) => {
          //
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const removeFavorite = (spaceId: string) => {
    if (!spaceId || removing[spaceId]) {
      return;
    }

    setRemoving((prev) => ({ ...prev, [spaceId]: true }));

    toggleFavoriteAction({ spaceId }, dispatch)
      .then((res) => {
        if (res.type === "success") {
          // Drop it from the visible list right away.
          setFavoriteList((prev) =>
            (prev || []).filter((item: any) => item?.id !== spaceId)
          );
          showToast("success", "Removed from your favorites.");
        } else {
          showToast(res.type, res.message);
        }
      })
      .catch((err) => {
        showToast("error", err.message);
      })
      .finally(() =>
        setRemoving((prev) => ({ ...prev, [spaceId]: false }))
      );
  };

  useEffect(() => {
    setFavoriteList(favoriteList);
  }, [favoriteList]);

  useEffect(() => {
    getFavoriteList();
  }, []);

  return (
    <PanelWrapper>
      <div className="container">
        <div className="page-header">
          <h2>Favorites</h2>
        </div>

        <div className="page-content-card">
          <div className="content-card-header">
            <h3>List of favorites spaces</h3>

            <div className="filter-area">
              {/* <div className="form-group">
                <DatePicker
                  showIcon
                  icon="far fa-calendar"
                  value={
                    filters.startDate
                      ? moment(filters.startDate).format("MM/DD/YYYY")
                      : ""
                  }
                  selected={filters.startDate}
                  className="form-control"
                  placeholderText="Start Date"
                  onChange={(date: Date | undefined) =>
                    onFilterChange("startDate", date)
                  }
                />
              </div>

              <div className="form-group">
                <DatePicker
                  showIcon
                  icon="far fa-calendar"
                  value={
                    filters.endDate
                      ? moment(filters.endDate).format("MM/DD/YYYY")
                      : ""
                  }
                  selected={filters.endDate}
                  className="form-control"
                  placeholderText="End Date"
                  onChange={(date: Date) => onFilterChange("endDate", date)}
                />
              </div>

              <CustomButton title="" onClick={() => getPaymentsList(1)}>
                <FontAwesomeIcon icon={faSearch} />
              </CustomButton> */}
            </div>
          </div>

          <div className="listing-tables">
            <Table responsive>
              <thead>
                <tr>
                  <th>Space Name</th>
                  <th>Capacity</th>

                  <th>Property Size</th>
                  <th>Price</th>
                  <th className="action-col">Action</th>
                </tr>
              </thead>

              <tbody>
                {loading && (
                  <tr>
                    <td colSpan={5} align="center">
                      <FontAwesomeIcon icon={faSpinner} spin />
                    </td>
                  </tr>
                )}

                {!loading && (!favoritesList || favoritesList.length === 0) && (
                  <tr>
                    <td colSpan={5} align="center">
                      No favorite spaces added
                    </td>
                  </tr>
                )}

                {!loading &&
                  favoritesList &&
                  favoritesList.map((item, index) => {
                    return (
                      <tr key={`property-${index}`}>
                        <td>{item.name}</td>
                        <td>{item?.capacity || 0} Person</td>

                        <td>{formatArea(item?.area)} sqft</td>
                        <td>{formatSpaceRate(item?.ratePerHour, { suffix: "/hr" })}</td>
                        <td className="action-col">
                          <ActionMenu
                            items={[
                              {
                                label: "Details",
                                icon: faChevronRight,
                                onClick: () =>
                                  window.open(
                                    `${webSiteUrl}/space/${item?.id}`,
                                    "_blank"
                                  ),
                              },
                              {
                                label: removing[item?.id]
                                  ? "Removing…"
                                  : "Remove",
                                icon: faHeartBroken,
                                variant: "danger",
                                onClick: () => removeFavorite(item?.id),
                              },
                            ]}
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>

              <tfoot>
                <tr>
                  <td colSpan={5}>
                    <Pagination
                      pagination={pagination}
                      onPageChange={(page) => getFavoriteList(page)}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </div>
      </div>
    </PanelWrapper>
  );
};

export default UsersFavoritesList;
